/*
 * @Author: your name
 * @Date: 2021-06-30 16:47:17
 * @LastEditTime: 2021-08-10 18:54:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\organization\index.js
 */
import request from '../request'

const server = {
  // getOrganzionTree:function (params) {
  //     return request.post('/ubm/organization/selectTree',params)
  // },
  getOrganzionTree: function (params) {
    return request.post('/ubm/organization/selectTreeHasStop', params)
  },
  addOrganzionTree: function (params) {
    return request.post('/ubm/organization/insert', params)
  },
  getOrganzionTreeNodeByID: function (params) {
    return request.post('/ubm/organization/queryById', params)
  },
  deleteOrganzionTreeNodeByID: function (params) {
    return request.post('/ubm/organization/delete', params)
  },
  updateOrganzionTree: function (params) {
    return request.post('/ubm/organization/update', params)
  },
  moveOrganzionTree: function (params) {
    return request.post('/ubm/organization/move', params)
  },
  selectCategoryByParentId: function (params) {
    return request.post('/product/category/selectCategoryByParentId', params)
  },
  // 新 
  queryApplyCategory: function (params) {
    return request.post('/product/categoryApply/queryApplyCategory', params)
  },

  //获取组织机构列表
  getInstitutionList: function (params) {
    return request.post('/ubm/organization/queryPage', params)
  },
  //查询某个公司下是否有组织机构数据
  hasOrganization: function (params) {
    return request.post('/ubm/organization/hasOrganization', params)
  },
  // 
  queryApplyCategoryTree: function (params) {
    return request.post('/product/categoryApply/queryApplyCategoryTree', params)
  },
  // 移动节点  ubm/organization/modifySortOrder
  modifySortOrder: function (params) {
    return request.fetch('/ubm/organization/modifySortOrder', params)
  },
}

export default server
